import { useCallback, useEffect, useState } from 'react';
import { analyticsService } from '../services/analyticsService';

export default function useInterveneFilterValues(fieldId, orgId, search = '') {
  const [values, setValues] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const load = useCallback(async () => {
    if (!fieldId) {
      setValues([]);
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    const res = await analyticsService.getInterveneFieldValues(fieldId, orgId, search);
    setValues(res.ok ? res.data?.values || [] : []);
    setIsLoading(false);
  }, [fieldId, orgId, search]);

  useEffect(() => {
    load();
  }, [load]);

  return { values, isLoading, reload: load };
}
